import { render, staticRenderFns } from "./conversationItem.vue?vue&type=template&id=9f482508&scoped=true&"
import script from "./conversationItem.vue?vue&type=script&lang=js&"
export * from "./conversationItem.vue?vue&type=script&lang=js&"
import style0 from "./conversationItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./conversationItem.vue?vue&type=style&index=1&id=9f482508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f482508",
  null
  
)

export default component.exports